import { DistressLevels, EdgeStyles, LeafTypes, ThicknessesTypes } from '../__generated/model/index.js';
import { Model } from '../index.js';
export const THICKNESS_OPTIONS = {
    [ThicknessesTypes.Standard]: {
        type: ThicknessesTypes.Standard,
        label: 'Standard',
        min: 0.75,
        max: 1.75,
        defaultValue: 1.75,
        pricing: {
            price: 0
        }
    },
    [ThicknessesTypes.Thick]: {
        type: ThicknessesTypes.Thick,
        label: 'Thick',
        min: 2,
        max: 2.25,
        defaultValue: 2.25,
        pricing: {
            price: 468
        }
    },
    [ThicknessesTypes.Rolled]: {
        type: ThicknessesTypes.Rolled,
        label: 'Rolled',
        min: 2,
        max: 3.5,
        defaultValue: 3,
        pricing: {
            price: 468
        }
    }
};
export const TOP_EDGE_STYLE_OPTIONS = {
    [EdgeStyles.Clean]: {
        type: EdgeStyles.Clean,
        label: 'Clean',
        pricing: {
            price: 0
        }
    },
    [EdgeStyles.NaturalWavy]: {
        type: EdgeStyles.NaturalWavy,
        label: 'Natural Wavy',
        pricing: {
            price: 0
        }
    },
    [EdgeStyles.Tumbled]: {
        type: EdgeStyles.Tumbled,
        label: 'Tumbled',
        pricing: {
            price: 0
        }
    },
    [EdgeStyles.Dupont]: {
        type: EdgeStyles.Dupont,
        label: 'Dupont',
        pricing: {
            price: 209
        }
    },
    [EdgeStyles.Beveled]: {
        type: EdgeStyles.Beveled,
        label: 'Beveled',
        pricing: {
            price: 209
        }
    }
};
export const TOP_DISTRESS_LEVEL_OPTIONS = {
    [DistressLevels.Clean]: {
        type: DistressLevels.Clean,
        label: 'Clean',
        description: 'No Distress'
    },
    [DistressLevels.Minimal]: {
        type: DistressLevels.Minimal,
        label: 'Minimal',
        description: 'Only a few small dings'
    },
    [DistressLevels.Light]: {
        type: DistressLevels.Light,
        label: 'Light',
        description: 'Noticeable and more distinct, but still very subtle'
    },
    [DistressLevels.Medium]: {
        type: DistressLevels.Medium,
        label: 'Medium',
        description: 'An increase of markings that are still not considerably noticeable'
    },
    [DistressLevels.Heavy]: {
        type: DistressLevels.Heavy,
        label: 'Heavy',
        description: 'A good deal of distress while boards remain level with no major gaps'
    },
    [DistressLevels.RoughSawn]: {
        type: DistressLevels.RoughSawn,
        label: 'Rough Sawn',
        description: 'Uneven boards with saw marks'
    }
};
export const AVAILABLE_LEAF_TYPES_MAP = {
    [Model.RectangleTop.type]: [
        LeafTypes.NoLeaf,
        LeafTypes.Standard,
        LeafTypes.Medium,
        LeafTypes.Large,
        LeafTypes.StandardDropIn,
        LeafTypes.MediumDropIn,
        LeafTypes.LargeDropIn,
        LeafTypes.CustomLeaf
    ],
    [Model.SquareTop.type]: [
        LeafTypes.NoLeaf
    ],
    [Model.RoundTop.type]: [
        LeafTypes.NoLeaf,
        LeafTypes.Perimeter,
        LeafTypes.StandardDropIn,
        LeafTypes.MediumDropIn,
        LeafTypes.LargeDropIn,
        LeafTypes.CustomLeaf
    ],
    [Model.EllipticalOvalTop.type]: [
        LeafTypes.NoLeaf,
        LeafTypes.StandardDropIn,
        LeafTypes.MediumDropIn,
        LeafTypes.LargeDropIn,
        LeafTypes.CustomLeaf
    ],
    [Model.RacetrackOvalTop.type]: [
        LeafTypes.NoLeaf,
        LeafTypes.StandardDropIn,
        LeafTypes.MediumDropIn,
        LeafTypes.LargeDropIn,
        LeafTypes.CustomLeaf
    ],
    [Model.BoatShapeTop.type]: [
        LeafTypes.NoLeaf,
        LeafTypes.StandardDropIn,
        LeafTypes.MediumDropIn,
        LeafTypes.LargeDropIn,
        LeafTypes.CustomLeaf
    ]
};
export const AVAILABLE_BASE_STYLES_MAP = {
    [Model.RectangleTop.type]: [
        Model.AnchorBase.type,
        Model.BellhouseBase.type,
        Model.BellyStretchedBase.type,
        Model.BrewerBase.type,
        Model.CaseyBase.type,
        Model.CraftsmanBase.type,
        Model.CrescentBase.type,
        Model.DanaBase.type,
        Model.FranklinBase.type,
        Model.HershBase.type,
        Model.MarksBase.type,
        Model.MeredithBase.type,
        Model.OswaldBase.type,
        Model.PeruStretchedBase.type,
        Model.RishBase.type,
        Model.RogersBase.type,
        Model.TamaraBase.type,
        Model.TuscanBase.type,
        Model.WaldenBase.type,
        Model.XBase.type,
        Model.AnglePictureFrameBase.type,
        Model.ArchBase.type,
        Model.BoxFrameBase.type,
        Model.MantisBase.type,
        Model.ReflectionBase.type,
        Model.ConnectedXBase.type,
        Model.SlimConnectedXBase.type,
        Model.SinglePostBase.type,
        Model.XMetalBase.type,
        Model.IvyBase.type,
        Model.DremorTurnedBase.type,
        Model.HerricksonTurnedBase.type,
        Model.MidModernTaperBase.type,
        Model.NarrowEnglishTurnedBase.type,
        Model.OldEnglishTurnedBase.type,
        Model.SlagleTurnedBase.type,
        Model.TraditionalBase.type,
        Model.TraditionalFlushBase.type,
        Model.TriflectionBase.type
    ],
    [Model.SquareTop.type]: [
        Model.AnchorSingleFeetBase.type,
        Model.AnchorSinglePlatformBase.type,
        Model.BellhouseSingleFeetBase.type,
        Model.BellhouseSinglePlatformBase.type,
        Model.BrewerSingleBase.type,
        Model.CraftsmanSingleBase.type,
        Model.CrescentSingleBase.type,
        Model.DanaSingleBase.type,
        Model.FranklinSingleFeetBase.type,
        Model.FranklinSinglePlatformBase.type,
        Model.MeredithSingleFeetBase.type,
        Model.MeredithSinglePlatformBase.type,
        Model.OswaldSingleBase.type,
        Model.ReededBase.type,
        Model.RishSingleBase.type,
        Model.RogersSinglePlatformBase.type,
        Model.TamaraSingleBase.type,
        Model.TuscanSingleFeetBase.type,
        Model.TuscanSinglePlatformBase.type,
        Model.WaldenSingleBase.type,
        Model.XSingleBase.type,
        Model.AnglePictureFrameSingleBase.type,
        Model.ArchSingleBase.type,
        Model.ReflectionCTCBase.type,
        Model.SlimConnectedXSingleBase.type,
        Model.SinglePostSingleBase.type,
        Model.XMetalSingleBase.type,
        Model.IvyBase.type,
        Model.DremorTurnedBase.type,
        Model.HerricksonTurnedBase.type,
        Model.MidModernTaperBase.type,
        Model.NarrowEnglishTurnedBase.type,
        Model.OldEnglishTurnedBase.type,
        Model.SlagleTurnedBase.type,
        Model.TraditionalBase.type,
        Model.TraditionalFlushBase.type
    ],
    [Model.RoundTop.type]: [
        Model.AnchorSingleFeetBase.type,
        Model.AnchorSinglePlatformBase.type,
        Model.BellhouseSingleFeetBase.type,
        Model.BellhouseSinglePlatformBase.type,
        Model.BrewerSingleBase.type,
        Model.CraftsmanSingleBase.type,
        Model.CrescentSingleBase.type,
        Model.DanaSingleBase.type,
        Model.FranklinSingleFeetBase.type,
        Model.FranklinSinglePlatformBase.type,
        Model.MeredithSingleFeetBase.type,
        Model.MeredithSinglePlatformBase.type,
        Model.OswaldSingleBase.type,
        Model.ReededBase.type,
        Model.RishSingleBase.type,
        Model.RogersSinglePlatformBase.type,
        Model.TamaraSingleBase.type,
        Model.TuscanSingleFeetBase.type,
        Model.TuscanSinglePlatformBase.type,
        Model.WaldenSingleBase.type,
        Model.XSingleBase.type,
        Model.AnglePictureFrameSingleBase.type,
        Model.ArchSingleBase.type,
        Model.ReflectionCTCBase.type,
        Model.SlimConnectedXSingleBase.type,
        Model.SinglePostSingleBase.type,
        Model.XMetalSingleBase.type
    ],
    [Model.EllipticalOvalTop.type]: [
        Model.AnchorBase.type,
        Model.BellhouseBase.type,
        Model.BellyStretchedBase.type,
        Model.BrewerBase.type,
        Model.CaseyBase.type,
        Model.CraftsmanBase.type,
        Model.CrescentBase.type,
        Model.DanaBase.type,
        Model.FranklinBase.type,
        Model.HershBase.type,
        Model.MarksBase.type,
        Model.MeredithBase.type,
        Model.OswaldBase.type,
        Model.PeruStretchedBase.type,
        Model.RishBase.type,
        Model.RogersBase.type,
        Model.TamaraBase.type,
        Model.TuscanBase.type,
        Model.WaldenBase.type,
        Model.XBase.type,
        Model.AnglePictureFrameBase.type,
        Model.ArchBase.type,
        Model.BoxFrameBase.type,
        Model.ConnectedXBase.type,
        Model.ReflectionBase.type,
        Model.SlimConnectedXBase.type,
        Model.SinglePostBase.type,
        Model.XMetalBase.type,
        Model.TriflectionBase.type
    ],
    [Model.RacetrackOvalTop.type]: [
        Model.AnchorBase.type,
        Model.BellhouseBase.type,
        Model.BellyStretchedBase.type,
        Model.BrewerBase.type,
        Model.CaseyBase.type,
        Model.CraftsmanBase.type,
        Model.CrescentBase.type,
        Model.DanaBase.type,
        Model.FranklinBase.type,
        Model.HershBase.type,
        Model.MarksBase.type,
        Model.MeredithBase.type,
        Model.PeruStretchedBase.type,
        Model.TamaraBase.type,
        Model.TuscanBase.type,
        Model.OswaldBase.type,
        Model.RishBase.type,
        Model.RogersBase.type,
        Model.WaldenBase.type,
        Model.XBase.type,
        Model.AnglePictureFrameBase.type,
        Model.ArchBase.type,
        Model.BoxFrameBase.type,
        Model.ConnectedXBase.type,
        Model.MantisBase.type,
        Model.ReflectionBase.type,
        Model.SlimConnectedXBase.type,
        Model.SinglePostBase.type,
        Model.XMetalBase.type,
        Model.TriflectionBase.type
    ],
    [Model.BoatShapeTop.type]: [
        Model.AnchorBase.type,
        Model.BellhouseBase.type,
        Model.BellyStretchedBase.type,
        Model.BrewerBase.type,
        Model.CaseyBase.type,
        Model.CraftsmanBase.type,
        Model.CrescentBase.type,
        Model.DanaBase.type,
        Model.FranklinBase.type,
        Model.HershBase.type,
        Model.MarksBase.type,
        Model.MeredithBase.type,
        Model.OswaldBase.type,
        Model.PeruStretchedBase.type,
        Model.RishBase.type,
        Model.RogersBase.type,
        Model.TamaraBase.type,
        Model.TuscanBase.type,
        Model.WaldenBase.type,
        Model.XBase.type,
        Model.AnglePictureFrameBase.type,
        Model.ArchBase.type,
        Model.BoxFrameBase.type,
        Model.ConnectedXBase.type,
        Model.MantisBase.type,
        Model.ReflectionBase.type,
        Model.SlimConnectedXBase.type,
        Model.SinglePostBase.type,
        Model.XMetalBase.type,
        Model.TriflectionBase.type
    ]
};
export const ROGERS_SINGLE_BASE_MAX_LENGTH_MAP = {
    [Model.RectangleTop.type]: 70,
    [Model.EllipticalOvalTop.type]: 90,
    [Model.RacetrackOvalTop.type]: 90,
    [Model.BoatShapeTop.type]: 70
};
export const getBaseInset = (tableLength)=>{
    if (tableLength >= 55 && tableLength <= 72) return 12;
    if (tableLength >= 73 && tableLength <= 90) return 14;
    if (tableLength >= 91 && tableLength <= 108) return 16;
    if (tableLength >= 109 && tableLength <= Number.MAX_SAFE_INTEGER) return 18;
    return -1;
};

//# sourceMappingURL=top-data.js.map